export default __webpack_public_path__ + "static/media/logo-light.d08be9aa.png";